import { format, parseISO, isValid, formatDistanceToNow } from 'date-fns';

// Standard date format: 15 Mar 2026
export function formatDate(d) {
  if (!d) return '-';
  try {
    const date = typeof d === 'string' ? parseISO(d) : new Date(d);
    if (!isValid(date)) return '-';
    return format(date, 'dd MMM yyyy');
  } catch { return '-'; }
}

// Date + time: 15 Mar 2026, 2:30 PM
export function formatDateTime(d) {
  if (!d) return '-';
  try {
    const date = typeof d === 'string' ? parseISO(d) : new Date(d);
    if (!isValid(date)) return '-';
    return format(date, 'dd MMM yyyy, h:mm a');
  } catch { return '-'; }
}

// Time only: 2:30 PM
export function formatTime(d) {
  if (!d) return '-';
  try {
    const date = typeof d === 'string' ? parseISO(d) : new Date(d);
    if (!isValid(date)) return '-';
    return format(date, 'h:mm a');
  } catch { return '-'; }
}

// Relative: "2 hours ago"
export function timeAgo(d) {
  if (!d) return '-';
  try {
    const date = typeof d === 'string' ? parseISO(d) : new Date(d);
    if (!isValid(date)) return '-';
    return formatDistanceToNow(date, { addSuffix: true });
  } catch { return '-'; }
}

// Short date for tables: 15/03/2026
export function formatDateShort(d) {
  if (!d) return '-';
  try {
    const date = typeof d === 'string' ? parseISO(d) : new Date(d);
    if (!isValid(date)) return '-';
    return format(date, 'dd/MM/yyyy');
  } catch { return '-'; }
}

// Today's date as YYYY-MM-DD (for inputs)
export function today() {
  return format(new Date(), 'yyyy-MM-dd');
}
